export type SuccessCarouselData = {
  id: number;
  name: string;
  text: string;
  mobileText: string;
  imageSrc: string;
};

const ASSISTANT_IMAGE_PATH = '/images/shidoIsTheBestAssistant';

export const SuccessStoriesCarouselData: SuccessCarouselData[] = [
  {
    id: 1,
    name: 'John Skelly - User since 2021',
    text: 'The number I cared about was my stress score. It’s down on most days, and the app showed me exactly which nights were causing it.',
    mobileText:
      'The number I cared about was my stress score. It’s down on most days, and the app showed me exactly which nights were causing it.',
    imageSrc: `${ASSISTANT_IMAGE_PATH}/john-skelly.png`,
  },
  {
    id: 2,
    name: 'Millie Gallo - User since 2022',
    text: 'It told me my worst sleep always followed a coffee after 2pm. I’d never have spotted that. Three weeks later I’m sleeping through.',
    mobileText:
      'It told me my worst sleep always followed a coffee after 2pm. I’d never have spotted that. Three weeks later I’m sleeping through.',
    imageSrc: `${ASSISTANT_IMAGE_PATH}/millie-gallo.png`,
  },
  {
    id: 3,
    name: 'Kailia Balewa - User since 2023',
    text: 'I barely log anything - my watch does most of it. My coach still noticed my energy dips only happen on days I don’t drink enough water.',
    mobileText:
      'I barely log anything - my watch does most of it. My coach still noticed my energy dips only happen on days I don’t drink enough water.',
    imageSrc: `${ASSISTANT_IMAGE_PATH}/kailia-balewa.png`,
  },
];
